import { diunaImperiumChapters } from './content';
export const diunaImperiumFaq = diunaImperiumChapters.find((chapter) => chapter.title.toLocaleUpperCase('pl').includes('FAQ'));
